"use client";

import React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheTailletStandard() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const businessName = "Taillet Real Estate and Property Management";
  const benefits = [{
    text: "Responsive communication"
  }, {
    text: "Local market expertise"
  }, {
    text: "Seamless tenant placement"
  }, {
    text: "Maintenance coordination"
  }, {
    text: "Financial reporting"
  }];
  return <section id="the-taillet-standard" ref={sectionRef} className="relative w-full py-20 lg:py-32 overflow-hidden bg-background">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-[10%] w-px h-full bg-border/40" />
        <div className="absolute top-[20%] left-0 w-full h-px bg-border/40" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          <div className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="bg-card/80 backdrop-blur-sm border border-border/50 p-8 md:p-12 lg:pr-24 shadow-lg relative z-0">
              <span className="text-primary font-medium tracking-widest uppercase text-sm mb-2 block">
                Our Philosophy
              </span>
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-6 leading-tight">
                Responsive Communication
              </h2>
              
              <Separator className="bg-primary h-1 w-24 mb-8" />
              
              <div className="space-y-6 text-muted-foreground text-lg leading-relaxed">
                <p>
                  At {businessName}, we believe that the foundation of successful property management is built on trust and transparency. Our "Responsive Communication" philosophy ensures that no question goes unanswered and no concern is overlooked.
                </p>
                <p>
                  We blend the rugged reliability of a Texas-based firm with the efficiency of modern technology. Whether you are a property owner seeking to maximize income or a resident looking for a well-maintained home, our team is dedicated to providing a seamless, professional experience.
                </p>
              </div>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {benefits.slice(0, 4).map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                    <CircleCheck className="w-5 h-5 text-primary shrink-0" />
                    <span className="text-foreground font-medium">{benefit.text}</span>
                  </div>)}
              </div>

              <div className="mt-10 pt-6 border-t border-border">
                <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
                  <Link to="/OurStoryPage">
                    Discover Our Story <ArrowRight className="ml-2 w-4 h-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          <div className={`lg:col-span-5 relative h-full min-h-[500px] lg:min-h-[700px] w-full transition-all duration-1000 delay-400 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative h-full w-full lg:-ml-16 lg:mt-12 z-10 shadow-2xl bg-cover bg-no-repeat bg-center !bg-[url(https://possible-pig.10web.cloud/wp-content/uploads/2026/02/Screenshot-2026-02-21-at-8.53.26-PM.png)]">
              <div className="absolute inset-0 bg-primary/10 mix-blend-multiply z-10 pointer-events-none" />
              
              
              
            </div>

            <div className="absolute -top-6 -right-6 w-full h-full border-2 border-primary/30 z-0 hidden lg:block" />
          </div>

        </div>
      </div>
    </section>;
}